"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lifeBase_1 = require("../types/lifeBase");
const potential_1 = require("../types/potential");
/**
 * Create a CC string from personality object.
 * @param personality Specify the personality object.
 * @return The CC string.
 */
exports.default = (personality) => {
    const { cycle, inner, lifeBase, outer, potentials, workStyle } = personality;
    const c1 = cycle % 10;
    const pcc = potentials.reduceRight((acc, cur) => `${acc}-${potential_1.cc[cur]}`, '');
    return `${inner}-${outer}-${workStyle}-${inner}${c1}-${lifeBase_1.cc[lifeBase]}${pcc}`;
};
//# sourceMappingURL=toCC.js.map